module.exports = __webpack_public_path__ + "static/media/banner5.cb2cc782.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/banner5.png
// module id = 47
// module chunks = 0